<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
          icon="icon-arrow-left"></vs-button>
        <vx-card>
          <info valueSize="26px" label="Master Stock Code" :value="dsv(gt.masterStockCode, gd.masterStockCode.data)" />

          <div class="flex flex-col md:flex-row">
            <div class="w-full md:w-1/2 bg-gray-100">
              <info label="Sub Stock Code" :value="dsv(gt.subStockCode, gd.subStockCode.data)" />
              <info label="Company" :value="dsv(gt.compId, gd.compId.data)" />
              <info label="Line Description" :value="gt.lineDescription" />
              <info label="Stock Balance" :value="gt.stockBalance + ' ' + gt.unit" />
              <info label="Zone" :value="dsv(gt.zone, gd.zone.data)" />

            </div>

            <div class="w-full md:w-1/2 bg-gray-200">
              <info label="Stock" :value="gt.stock" />
              <info label="Gasket Type" :value="gt.gasketType" />
              <info label="Gasket Type Detail" :value="gt.gasketDetails" />
              <info label="Size / Dimension" :value="gt.sizeDimension" />
              <info label="Thickness" :value="gt.thickness" />
              <info label="Location" :value="dsv(gt.location, gd.location.data)" />
              <info label="Shelf" :value="dsv(gt.shelf, gd.shelf.data)" />
            </div>
          </div>

        </vx-card>
      </div>
      <div class="vx-col w-full md:w-2/3">

        <div class="flex flex-wrap-reverse items-center">


          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <h3>Stock Movement</h3>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider>Goods Received</vs-divider>
        <div class="row">
          <div class="col-md-12 pt-5">
            <stock-table title="Goods Received" :showActionButton="false" :filter="filter" @selected="selected"
              uploadEndpoint="/uploadFile" endPoint="search_goodsreceivesByMastercode"
              filterEndpoint="search_goodsreceivesByMastercode" key="search_goodsreceivesByMastercode"></stock-table>
          </div>
        </div>

        <vs-divider>Goods Sent Out</vs-divider>
        <div class="row">
          <div class="col-md-12 pt-5">
            <stock-table title="Goods Sent Out" :showActionButton="false" :filter="filter" uploadEndpoint="/uploadFile"
              endPoint="search_goodsSentoutByMastercode" filterEndpoint="search_goodsSentoutByMastercode"
              key="search_goodsSentoutByMastercode"></stock-table>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
//get the profile/setCurrentMainInfo from the store
import { mapGetters } from "vuex";
import { helperMixin } from "../../mixin/helperMixin";
import info from "./info.vue"
import StockTable from "@/components/aron/table/stockMovement.vue";
import { axiosMixin } from '@/mixin/axiosMixin';
export default {
  mixins: [helperMixin, axiosMixin],
  props: ["id"],
  components: {
    info,
    StockTable
  },
  data() {
    return {

    };
  },
  methods: {
    getData() {
      this.aronPost('getCombineTableForGRandGS', {}, '', '')
        .then(response => {
          if (response.status) {

          } else {
            this.errorAlert('Error', response.data.error);
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })
    },
    dsv(value, options) {
      return this.decodeValueForSelect(options, value);
    },
  },
  computed: {
    ...mapGetters({
      gt: "profile/gt",
      gd: "profile/gd",
    }),
    filterEndpoint() {
      return "search_goodsreceives";
    },
    filter() {
      return { advanceFilter: { masterStockCode: this.gt.masterStockCode } }
    }
  },
  mounted() {
    this.getData();
  }

};
</script>
